import { InspectionImageFilters } from "../_objects/inspection-image-filters";
import { DEFAULT_SORT_SETTING } from "../app.constants";

export const InspectionImageFiltersFixture = (props?: Partial<InspectionImageFilters>): InspectionImageFilters => ({
  subjectLocation: null,
  marks: [],
  sort: DEFAULT_SORT_SETTING.SORT,
  sortOrder: DEFAULT_SORT_SETTING.SORTORDER,
  printScreens: [],
  ...props
});